import {
  Accordion,
  AccordionContent,
  AccordionPanel,
  AccordionTitle,
} from "flowbite-react";
import { Info } from "lucide-react";
import { default as Step } from "@/features/auth/components/LoginForm/Forms/FormParts/TwoFaNotice/TwoFaNoticeStep/TwoFaNoticeStep";
import { useTwoFaTimers } from "@/features/auth/hooks/useTwoFaTimers";

const isStepActive = ({ current, previous }: { current?: number, previous?: number }) => (current === undefined || current > 0) && !previous;

type TwoFaNoticeProps = { timestamp: number };

const TwoFaNotice = ({ timestamp }: TwoFaNoticeProps) => {
  const { firstCall, secondCall, pinExpiration } = useTwoFaTimers(timestamp);

  return (
    <Accordion
      collapseAll
      className="shadow-none p-0 m-0"
    >
      <AccordionPanel>
        <AccordionTitle className="flex w-full items-center justify-end gap-2 text-sm cursor-pointer hover:bg-transparent border-none shadow-none h-auto p-0 pb-4">
          <span className="flex w-full items-center justify-end gap-2 text-sm">
            <Info size={16} />
            Plus d'informations.
          </span>
        </AccordionTitle>
        <AccordionContent className="relative space-y-5 p-0 transition-all duration-300">
          <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-gray-200" />

          <Step
            icon="CheckCircle"
            title="Code de vérification envoyé"
            description={`${firstCall} secondes avant l'étape suivante`}
            isActive={isStepActive({ current: firstCall })}
          />

          <Step
            icon="PhoneCall"
            title="1er appel téléphonique"
            description={`${secondCall} secondes avant l'étape suivante`}
            isActive={isStepActive({ current: secondCall, previous: firstCall })}
          />

          <Step
            icon="PhoneCall"
            title="2nd appel téléphonique"
            description={`${pinExpiration} secondes avant l'étape suivante`}
            isActive={isStepActive({ current: pinExpiration, previous: secondCall })}
          />

          <Step
            icon="CircleX"
            title="Code de vérification expiré"
            isActive={isStepActive({ previous: pinExpiration })}
            activeColor="text-red-600"
          />
        </AccordionContent>
      </AccordionPanel>
    </Accordion>
  );
};

export default TwoFaNotice;
